/**
 * User-facing label for the contract's monetary value, shared by every contract view
 * (Contracts table, Supplier contracts sub-list, Create/Edit form, CSV export, detail page)
 * so the term cannot drift again (ADO-1091/1132).
 */
export const CONTRACT_AMOUNT_LABEL = 'Contract Amount';
